module.exports = __webpack_public_path__ + "static/media/meinVisual_verb.5966e431.svg";